import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('addReportDashboardModal', [
  'SET_SELECTED_PAPERS',
  'CLEAR_SELECTED_PAPERS',

  'FLUSH_ADD_REPORT_DASHBOARD_MODAL',

  'SET_MODAL_COPY',
  'SET_MODAL_ANALYTICS'
])

export const setSelectedPapers = payload => ({
  type: constants.SET_SELECTED_PAPERS,
  payload
})

export const clearSelectedPapers = () => ({
  type: constants.CLEAR_SELECTED_PAPERS
})

export const flushAddReportDashboardModal = () => ({
  type: constants.FLUSH_ADD_REPORT_DASHBOARD_MODAL
})

export const setModalCopy = payload => ({
  type: constants.SET_MODAL_COPY,
  payload
})

export const setModalAnalytics = payload => ({
  type: constants.SET_MODAL_ANALYTICS,
  payload
})
